import React, { Component } from "react";
import PropTypes from "prop-types";
import TypographyKit from "../../../components/kit/Typography/TypographyKit";
import IconSearch from "../../../components/kit/Icon/IconSearch";
import FormField from "../../../components/kit/Fields/FormField/FormField";
import { ContentBody, ContentHead } from "../styled";
import Empty from "../../../components/presentation/Empty/Empty";
import Email from "../../../components/smart/Email/Email";
import { withRouter } from "react-router-dom";
import { compose } from "redux";
import { connect } from "react-redux";
import {
  fetchScheduledEmails,
  setScheduledEmails
} from "../../../store/communication/actions";
import Loader from "../../../components/presentation/Loader/Loader";
import withWidth from "../../../hoc/withWidth";
import { api } from "../../../index";

class CommunicationScheduled extends Component {
  constructor(props) {
    super(props);

    this.state = {
      searchValue: ""
    };
  }
  componentDidMount() {
    this.props.fetchScheduledEmails();
  }

  async searchEmails() {
    try {
      const resp = await api.searchEmails("sent", this.state.searchValue);
      const emails = resp.data.docs;
      this.props.setScheduledEmails(emails);
    } catch (err) {
      console.log(err);
    }
  }

  handleChange(value) {
    this.setState(
      {
        searchValue: value
      },
      this.searchEmails
    );
  }

  handleRedirect = id =>
    this.props.history.push(`${this.props.location.pathname}/${id}`);

  render() {
    const { searchValue } = this.state;
    const { emails, loading, width } = this.props;
    const emailsNotEmpty = emails && emails.length > 0;
    const emailsIsSearching = emailsNotEmpty || searchValue !== "";

    return loading ? (
      <Loader isBlock />
    ) : (
      <>
        <ContentHead>
          <TypographyKit variant={"caption1"}>SCHEDULED</TypographyKit>
          {emailsIsSearching && (
            <FormField
              label={
                width > 520
                  ? null
                  : "Search tournaments, organizations or by email address…"
              }
              fullWidth
              iconAlign={"left"}
              icon={<IconSearch />}
              value={searchValue}
              placeholder={
                width > 520
                  ? "Search tournaments, organizations or by email address…"
                  : null
              }
              onChange={this.handleChange.bind(this)}
            />
          )}
        </ContentHead>
        <ContentBody>
          {emailsNotEmpty ? (
            emails.map((item, index) => (
              <Email
                handleClick={() => this.handleRedirect(item.id)}
                key={index}
                {...item}
              />
            ))
          ) : (
            <Empty
              message={
                emailsIsSearching
                  ? "SCHEDULED EMAILS NOT FOUND"
                  : "YOU HAVE NO SCHEDULED EMAILS"
              }
            />
          )}
        </ContentBody>
      </>
    );
  }
}

CommunicationScheduled.propTypes = {
  loading: PropTypes.bool,
  emails: PropTypes.arrayOf(PropTypes.object),
  fetchScheduledEmails: PropTypes.func.isRequired,
  setScheduledEmails: PropTypes.func.isRequired
};

const mapStateToProps = state => ({
  emails: state.communication.scheduled,
  loading: state.communication.loading
});

const mapDispatchToProps = {
  fetchScheduledEmails,
  setScheduledEmails
};

export default compose(
  withWidth,
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(CommunicationScheduled);
